module.exports = __webpack_public_path__ + "static/media/comboExample.aa0927b9.png";